export const mineralFertilisationGraphTheme = {
    color: ['#C14022', '#FFB34E', '#FDD980', '#ED8770', '#FFC3B5', '#413EDD', '#CBD6FF', '#85A0FF', '#FFF1CE'],
};
